import React, { useEffect, useState } from "react";

import "./Avatar.css";

/** Photo if the user has one, otherwise their initial on a soft colour. */
const Avatar = ({ user, size = 44, decorative = true }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [user?.photoUrl]);

  const style = { width: size, height: size };
  const name = user?.name || "";

  if (user?.photoUrl && !failed) {
    return (
      <img
        className="avatar"
        src={user.photoUrl}
        alt={decorative ? "" : name}
        width={size}
        height={size}
        style={style}
        // Google profile photos (lh3.googleusercontent.com) often refuse requests
        // that send a referrer from another site.
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
      />
    );
  };

  return (
    <span
      className="avatar avatar--initial"
      aria-hidden={decorative ? "true" : undefined}
      aria-label={decorative ? undefined : name}
      style={{
        ...style,
        fontSize: Math.round(size * 0.4),
        background: user?.avatarColor || "#DCD2F6",
      }}
    >
      {(name.charAt(0) || "?").toUpperCase()}
    </span>
  );
};

export default Avatar;
